/** Show the HTML `#splash-screen` logo overlay. */
export const enableSplashScreen = () => {
  const splashScreen = document.getElementById("splash-screen");
  if (splashScreen) {
    splashScreen.style.setProperty("display", "flex");
  }
  document.body.classList.add("page-loading");
};

/** Hide the HTML `#splash-screen` logo overlay. */
export const disableSplashScreen = () => {
  const splashScreen = document.getElementById("splash-screen");
  if (splashScreen) {
    splashScreen.style.setProperty("display", "none");
  }
  document.body.classList.remove("page-loading");
};
